import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { AdminPromosCatalogKey } from './promos.i18n.js';
import { ADMIN_PROMOS_CATALOG } from './promos.i18n.js';

export type AdminPromosMessageId = `adminPromos:${AdminPromosCatalogKey}`;

const PREFIX_LENGTH = 'adminPromos:'.length;

/** `t()` for the stop-gap `adminPromos:` scope (see `promos.i18n.ts`). */
export function usePromosT(): { t: (id: AdminPromosMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: AdminPromosMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as AdminPromosCatalogKey;
      const raw = ADMIN_PROMOS_CATALOG[locale][key] ?? ADMIN_PROMOS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
